export const channelDashboardData = "/channel_dashboard/:app_group_id/:channel_type" as const;
